import { storage } from '@/lib/storage'

import {
  defaultCookiePreferences,
  PREFERENCES_COOKIES_PREFIX_KEY,
  PreferencesCookiesKey,
} from '@/constants/preferences'

export const setCookiePreference = (key: PreferencesCookiesKey, newValue: string | number | boolean) => {
  storage.set(`${PREFERENCES_COOKIES_PREFIX_KEY}.${key}`, String(newValue))
}

export const getCookiePreference = <T extends PreferencesCookiesKey>(
  key: T,
): (typeof defaultCookiePreferences)[T]['default'] => {
  const storageKey = `${PREFERENCES_COOKIES_PREFIX_KEY}.${key}`
  const value = storage.get(storageKey)

  const cookieSchema = defaultCookiePreferences[key]

  if (!value) {
    return cookieSchema.default
  }

  if (cookieSchema.type === 'number') {
    return Number(value) as (typeof defaultCookiePreferences)[T]['default']
  }

  if (cookieSchema.type === 'boolean') {
    return (value === 'true') as (typeof defaultCookiePreferences)[T]['default']
  }

  return value as (typeof defaultCookiePreferences)[T]['default']
}

// export const getLineLoginCookies = async () => {
//   let getProfile
//   await liff.init({ liffId: '2004777370-er6nOw9a' }).catch((err) => {
//     throw err
//   })
//   if (liff.isLoggedIn()) {
//     getProfile = await liff.getProfile()
//   } else {
//     liff.login()
//   }
//   return getProfile
// }
